interface PageTitleProps {
	name: string;
}

export const PageTitle: React.FC<PageTitleProps> = ({ name }) => <title>{`Scheduling: ${name}`}</title>;
